export default function EFPlay(props: any) {
    return (
        <svg width="36px" height="36px" viewBox="0 0 36 36" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="1月5号版本" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g transform="translate(-274.000000, -12700.000000)" fillRule="nonzero" id="编组-2备份-4">
                    <g transform="translate(160.000000, 12643.000000)">
                        <g id="01-1视频播放button备份-5" transform="translate(114.000000, 57.000000)">
                            <path
                                d="M18,0.5625 C22.8152327,0.5625 27.1746077,2.51425864 30.3301745,5.66982543 C33.4857414,8.82539227 35.4375,13.1847673 35.4375,18 C35.4375,22.8152327 33.4857414,27.1746077 30.3301746,30.3301745 C27.1746078,33.4857413 22.8152328,35.4375 18,35.4375 C13.1847672,35.4375 8.82539223,33.4857413 5.66982542,30.3301745 C2.51425861,27.1746077 0.5625,22.8152327 0.5625,18 C0.5625,13.1847673 2.51425863,8.82539231 5.66982546,5.66982547 C8.82539226,2.51425865 13.1847673,0.5625 18,0.5625 Z"
                                id="路径"
                                stroke="#FFFFFF"
                                strokeWidth="1.125"
                            ></path>
                            <path
                                d="M14.4220956,11.25 C13.9128351,11.25 13.5,11.6590795 13.5,12.1637048 L13.5,12.1637048 L13.5,24.9611655 C13.5,25.1297649 13.5470767,25.2950768 13.636022,25.4388053 C13.9022384,25.868991 14.4699855,26.0038789 14.904121,25.7400857 L14.904121,25.7400857 L25.4347992,19.3413554 C25.5586919,19.2660743 25.662874,19.162841 25.7388473,19.0400749 C26.0050618,18.6098892 25.8689365,18.0473081 25.4347992,17.783515 L25.4347992,17.783515 L14.904121,11.3847846 C14.7590736,11.2966492 14.5922425,11.25 14.4220956,11.25 Z"
                                id="路径"
                                fill="#FFFFFF"
                            ></path>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
